export default __webpack_public_path__ + "assets/apple-icon-152x152.51699066d8a56916699015e61e23de39.png";